exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Image-module__image___1RupT{height:100%;color:#169ab5;font-size:20px}.Image-module__image___1RupT.Image-module__folder___3WFQs{color:#1e265c}", ""]);

// exports
exports.locals = {
	"image": "Image-module__image___1RupT",
	"folder": "Image-module__folder___3WFQs"
};